import { APIRoutes } from '../../routes';
import { Config } from '../../utils/config';
import apiInstance from '../index';

export interface HangfireDashboardCodeResponse {
    code: string;
}

export async function postHangfireDashboardSession(): Promise<HangfireDashboardCodeResponse> {
    return (await apiInstance.post<HangfireDashboardCodeResponse>(APIRoutes.HANGFIRE_DASHBOARD_SESSION))
        .data;
}

export function getHangfireDashboardRedeemUrl(code: string): string {
    const query = new URLSearchParams({ code });
    return `${Config.BaseApiUrl}/originations-review-portal${APIRoutes.HANGFIRE_DASHBOARD_SESSION}?${query}`;
}
